<template>
  <nav class="navbar navbar-expand-lg scrolled  fixed-top ">
    <div class="container">
      <router-link class="navbar-brand" to="/" >
            <img height="70" src="../assets/rsz_afcfta_number.jpg"   alt=""> 
      </router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <i class="fas fa-bars"></i>
      </button>
      <div class="collapse navbar-collapse " id="navbarNav">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item active">
            <a class="nav-link" href="#about">About </a>
          </li>
          <li class="nav-item text-danger">
            <a class="nav-link" href="#howitworks">How It works</a>
          </li>
          <li class="nav-item">
            <a target="_blank" class="nav-link" href="https://afcfta.blog/">Blog</a>
          </li>
          <li class="nav-item">
            <a target="_blank" class="nav-link" href="https://afcfta.app/">App</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#contact">Contact</a>
          </li>
           <li class="nav-item" v-if="!user">
            <div class="d-flex pt-2">
              <a class=" text-white" href='/redirect?service=register'>Signup</a> 
              <span class="pr-1" style="color:#bf2a38; font-weight:bolder">/</span>
              <a class=" text-white" href='/redirect?service=login'>Login</a>
            </div>
        </li>
        <li class="nav-item" v-if="user">
          <a @click="logout" class="nav-link text-white" 
          :href="`${url()}/accounts/logout?${service()}`">Logout</a>
        </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import $ from "jquery";
import url from '../url'
import service from '../helpers/service'
$(window).scroll(function() {
  $("nav").toggleClass("scrolled", $(this).scrollTop() > 10);
});
export default {
  data() {
    return {
      user :null
    }
  },
  methods:{
     url() {
      return url()
    },
    service() {
      return service()
    },
    logout() {
      Storage.removeAll()
      this.$session.remove('entity')
    },
   getUser() {
      this.user = this.$session.get('entity')
    },
  },
  created() {
    this.getUser()
  }
};
</script>

<style scoped>
.scrolled{
  background-color:#fff ;
}
nav{
  background-color: #fff ;
}
a {
  text-transform: uppercase;
  margin-right: 10px;
  font-size: 17px;
  color: #bf2a38 !important;
  font-weight: bolder;
} 

.bg-light.scrolled {
  background: #f8f9fa !important;
}
.navbar-toggler{
  color:#bf2a38 !important;
  font-size: 2em;
  border:0px;
  outline: none !important;
}
.navbar-toggler:hover{
  outline:none;
  border:transparent;
}
</style>
